import { ajax } from '@/util/ajax'
const BASE_URL = '/gateway/platform-lmsapi/complaint'

const ComplaintApi = {
  getComplaintQueue (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/list-queue-data`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getComplaintQueueCount (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/get-queue-count`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getComplaintDetail (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/list-complaint-data-detail`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  complaintReply (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/submit-complaint-comments`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  complaintResolve (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/resolve`,
      input,
      success,
      failure
    )
  },
  loanComplaint (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/loan-complaint-data`,
      input,
      success,
      failure
    )
  }
}
export { ComplaintApi }
